module.exports = __webpack_public_path__ + "img/quarterTwo.61d5847c.png";